export default "__VITE_ASSET__B34Bh2r1__"